@if (padding()) {
  <button (click)="onButtonClick()" class="rounded-full cursor-pointer p-2" [ngClass]="!disabled() ? 'bg-white' : 'bg-gray-300'" [disabled]="disabled()">
    <vti-icons [icon]="icon()" [size]="iconSize()" [color]="!disabled() ? 'vti' : 'gray-500'"></vti-icons>
  </button>
} @else {
  <button (click)="onButtonClick()" class="rounded-full cursor-pointer" [ngClass]="!disabled() ? 'bg-white' : 'bg-gray-300'" [disabled]="disabled()">
    <vti-icons [icon]="icon()" [size]="iconSize()" [color]="!disabled() ? 'vti' : 'gray-500'"></vti-icons>
  </button>
}
